import React from 'react';
import {
  Container,
  Paper,
  Box,
  Typography,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const PageNotAccessible: React.FC = () => {
  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '80vh',
          justifyContent: 'center',
        }}
      >
        <Paper 
          elevation={3} 
          sx={{ 
            padding: 6, 
            width: '100%',
            textAlign: 'center',
            borderRadius: 3,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                backgroundColor: 'error.light',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 3,
              }}
            >
              <LockOutlinedIcon sx={{ fontSize: 40, color: 'error.main' }} />
            </Box>
            
            <Typography component="h1" variant="h4" fontWeight="bold">
              Page Not Accessible
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default PageNotAccessible;
